
import { defineComponent } from '@vue/composition-api'
import { StatusBlock } from '05-ui-kit'
import ErrorSerializer from '~/serializer/Error'
import type Brand from '~/type/Brand'
import type Brands from '~/api/brand.api'
type RequestType = Awaited<ReturnType<typeof Brands.get>>

interface Options {
  includeScore: boolean
  threshold: number
  location: number
  distance: number
  maxPatternLength: number
  minMatchCharLength: number
  keys: string[]
}

export default defineComponent({
  name: 'BrandPage',
  components: {
    StatusBlock,
  },
  async asyncData({ app, $pageError }) {
    try {
      const response = (await app.$api.brand.get())?.result.list

      return {
        list: response,
      }
    }
    catch (e) {
      const error = ErrorSerializer(e)
      new $pageError({
        ...error,
        message: error.code === 404 ? 'Бренды не найдены' : error.message,
      })
    }
  },
  data(): { list?: RequestType; searchResult: { item: Brand }[]; query: string; options: Options } {
    return {
      list: undefined,
      searchResult: [],
      query: '',
      options: {
        includeScore: true,
        threshold: 0.25,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ['name'],
      },
    }
  },
  head: {
    title: 'Бренды',
  },
  methods: {
    navigateTo(path: string) {
      this.$router.push(path)
    },
    getSearchResult(result: { item: Brand }[]) {
      this.searchResult = result
    },
    input(query: string) {
      this.query = query
    },
  },
})
